import { createContext } from "react";

const CustomerDetailsContext = createContext();

export default CustomerDetailsContext;
